import {Exclude} from 'class-transformer';
import {Request} from '../request.model';
import {CommonResponse} from './common.response';
import {Type as TType} from '@angular/core';
import {TerminalResponse} from '../response.model';
export class CommonRequest extends Request {
    @Exclude()
    public id: string;

    constructor(table?) {
        super();
    }

    deserializerClass(): TType<TerminalResponse> {
        return CommonResponse;
    }
}
